import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance, { setBaseURL } from '../api/axios';

interface MenuPlanState {
  loading: boolean;
  error: string | null;
}

const initialState: MenuPlanState = {
  loading: false,
  error: null,
};

// Async thunk for deleting menu details
export const deleteMenuDetails = createAsyncThunk<void, { 
  menuPlanIds?: number[], 
  userId?: string, 
  menuPlanTypeId?: number, 
  dayPartId?: number, 
  fromDate?: string, 
  toDate?: string, 
  siteIdList?: any[], 
  isAllSite?: boolean, 
  isAllCafe?: boolean, 
  cafeIdList?: number[] 
}>(
  'menuPlans/clearAllMenu',
  async ({ userId, menuPlanTypeId, dayPartId, fromDate, toDate, siteIdList, isAllSite, isAllCafe, cafeIdList }) => {
    // Set the base URL dynamically (optional based on the endpoint)
    setBaseURL(`${BASE_URL}/api/v1/InitiateMenuPlan`);

    const url = '/ClearAllMenuPlan';

    const requestBody: any = {};

    if (userId !== undefined) requestBody.userid = userId;
    if (menuPlanTypeId !== undefined) requestBody.menuplantypeid = menuPlanTypeId;
    if (dayPartId !== undefined) requestBody.daypartid = dayPartId;
    if (fromDate !== undefined) requestBody.fromdate = fromDate;
    if (toDate !== undefined) requestBody.todate = toDate;
    if (siteIdList !== undefined) requestBody.siteidlist = siteIdList;
    if (isAllSite !== undefined) requestBody.isallsite = isAllSite;
    if (isAllCafe !== undefined) requestBody.isallcafe = isAllCafe;
    if (cafeIdList !== undefined) requestBody.cafeidlist = cafeIdList;

    await axiosInstance.request({
      url: url,
      method: 'PUT', 
      headers: {
        'accept': '*/*',
        'Content-Type': 'application/json',
      },
      data: requestBody,
    });
  }
);

const clearAllMenuSlice = createSlice({
  name: 'clearAllMenu',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteMenuDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMenuDetails.fulfilled, (state) => {
        state.loading = false;
        toast('Data cleared successfully!', {
          type: 'success'
        });
      })
      .addCase(deleteMenuDetails.rejected, (state, action) => {
        state.loading = false;
        const errorMessage = action.error?.message || 'Something went wrong!';
        state.error = errorMessage;
        toast(`Error: ${errorMessage}`, {
          type: 'error', 
        });
      });
  },
});

export default clearAllMenuSlice.reducer;
